/*
 * Scroll-reveal primitive.
 *
 * One shared IntersectionObserver toggles `.is-visible` on every element that
 * carries `data-dev-reveal`, once, as it scrolls into view. The visual side
 * lives in assets/dev-reveal.css; this file only adds/removes the class.
 *
 * Mirrors assets/dev-scroll-to-top.js: classic IIFE (not a module), dataset
 * init guard, shopify:section:load re-init for the theme editor. Bails entirely
 * when the global toggle is off — the arming class is absent in that case.
 *
 * window.DevReveal.scan(root) is exposed so AJAX-injected content (e.g. a
 * future collection filter) can register newly added nodes.
 */
(function () {
  'use strict';

  var ROOT = document.documentElement;

  // Global toggle: the arming class is only added (synchronously, in <head>)
  // when settings.dev_animations_enabled is on. No class -> animations off.
  if (!ROOT.classList.contains('dev-reveal-ready')) return;

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    document.querySelectorAll('[data-dev-reveal]').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  // No IntersectionObserver support, or user opted out of motion: show
  // everything immediately. (CSS also force-shows on reduced-motion; this is a
  // belt-and-suspenders for the no-IO case and keeps state consistent.)
  if (reduceMotion || !('IntersectionObserver' in window)) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealAll);
    } else {
      revealAll();
    }
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); // one-shot: never replays
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  function scan(root) {
    (root || document)
      .querySelectorAll('[data-dev-reveal]')
      .forEach(function (el) {
        if (el.dataset.devRevealObserved === '1') return;
        el.dataset.devRevealObserved = '1';
        observer.observe(el);
      });
  }

  function boot() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders a section -> observe its freshly injected nodes.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) scan(e.target);
  });

  // Public hook for AJAX-injected content (e.g. collection filter/sort).
  window.DevReveal = { scan: scan };
})();
